import Index from '../components/NextTrips/IndexWebview'


let routes = {
    path: '/next-trips',
    component: resolve => require(['../components/layout/Blank'], resolve),
    children: [
        {
            path: '/next-trips-webview',
            name: 'Próximas Viagens  Web',
            component: Index,
        },

    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/next_trips_webview.js